import { createReducer } from 'utils/reduxCreators';
import { fetchFeatureFlags } from 'services/featureFlags';
import { updateAppLoading } from './meta';

export const RECEIVED_FEATURE_FLAGS = 'featureFlags/RECEIVED_FEATURE_FLAGS';

const initialState = {
  isSuspensionRulesEnabled: false,
  isSsoManagementEnabled: false,
};

export default createReducer(initialState, {
  [RECEIVED_FEATURE_FLAGS]: (state, { payload }) => {
    return {
      ...state,
      ...payload,
    };
  },
});

export const getFeatureFlags = () => async (dispatch) => {
  dispatch(updateAppLoading(true));
  try {
    const result = await fetchFeatureFlags();
    dispatch(updateAppLoading(false));
    dispatch({ type: RECEIVED_FEATURE_FLAGS, payload: result });
  } catch (e) {
    dispatch(updateAppLoading(false));
    // Important to throw it back as it gets caught by the middleware.
    throw e;
  }
};
